export var getBlockStyle = function (block) {
    switch (block.getType()) {
        case 'blockquote':
            return 'RichEditor-blockquote';
        case 'alignLeft':
            return 'RichEditor-alignLeft';
        case 'alignRight':
            return 'RichEditor-alignRight';
        case 'alignCenter':
            return 'RichEditor-alignCenter';
        case 'alignJustify':
            return 'RichEditor-alignJustify';
        default:
            return 'unstyled';
    }
};
//# sourceMappingURL=styleUtils.js.map